export const ADD_NEW_SAMPLE_MODAL_KEY = "NEW_SAMPLE_MODAL_KEY";
export const ADD_EXISTING_SAMPLE_MODAL_KEY = "ADD_EXISTING_SAMPLE_MODAL_KEY";
export const EDIT_SAMPLE_MODAL_KEY = "EDIT_SAMPLE_MODAL_KEY";
export const CHAIN_OF_CUSTODY_FORM = "CHAIN_OF_CUSTODY_FORM";
